module.exports = __webpack_public_path__ + "static/media/zola-weddings-logo-white.6b4c6f34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/zola-weddings-logo-white.svg
// module id = 1616
// module chunks = 46